var symphony = symphony || {};

;(function() {

    symphony.displayLocationMap_map = null;
	symphony.displayLocationMap = function(elm, addr, name) {
        var loc_lat = addr.lat != null && addr.lat != "null" ? $.trim((addr.lat).toString()) : '';
        var loc_lng = addr.long || addr.lng;
        loc_lng = loc_lng != null && loc_lng != "null" ? $.trim(loc_lng.toString()) : '';
        var name = name || addr.unitShortName;
        var loc_addr = '';

        addr.address1 = addr.address1 != null ? $.trim(addr.address1.replace(/\(NO MAIL\)/g, '').replace(/\(no mail\)/g, '').replace(/\(All Mail\)/g, '').replace(/\(Mail \& Deliveries\)/g, '').replace(/\(ALL MAIL\/DELIVERIES\)/g, '').replace(/\(NO MAIL\/DELIVERIES\)/g, '')) : '';
        addr.address2 = addr.address2 != null ? $.trim(addr.address2.replace(/\(NO MAIL\)/g, '').replace(/\(no mail\)/g, '').replace(/\(All Mail\)/g, '').replace(/\(Mail \& Deliveries\)/g, '').replace(/\(ALL MAIL\/DELIVERIES\)/g, '').replace(/\(NO MAIL\/DELIVERIES\)/g, '')) : '';
        addr.city = addr.city != null ? $.trim(addr.city) : '';
        addr.state = addr.state != null ? $.trim(addr.state) : '';
        addr.zip = addr.zip != null ? $.trim(addr.zip) : '';
        
        loc_addr += addr.address1;
        loc_addr += (loc_addr != '' && addr.address2 != '' ? '<br />' : '') + addr.address2;
        loc_addr += (loc_addr != '' && addr.city != '' ? '<br />' : '') + addr.city;
        loc_addr += (loc_addr != '' && addr.state != '' ? ', ' : '') + addr.state;
        loc_addr += (loc_addr != '' && addr.zip != '' ? ' ' : '') + addr.zip;

        loc_addr_joined = loc_addr.replace(/\<br \/\>/g, '+').replace(/ /g, '+').replace(/\./g, '');

        if (loc_lat != "" && loc_lng != "") {
            symphony.displayLocationMap_map = new GMaps({
                el: elm,
                lat: loc_lat,
                lng: loc_lng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            var marker = symphony.displayLocationMap_map.addMarker({
                lat: loc_lat,
                lng: loc_lng,
                title: name,
                click: function(e) {
                    symphony.displayLocationMap_infoWindow(name, loc_addr, loc_addr_joined, this);
                },
                icon: {
                    size: new google.maps.Size(24,39),
                    url: gdosWrapper.config.icon
                }
            });

            symphony.displayLocationMap_infoWindow(name, loc_addr, loc_addr_joined, marker);
        } else {
            $(elm).html('\
                <div class="u-textCenter">This center has no address</div>\
            ');
        }
    };

    symphony.displayLocationMap_infoWindow = function(name, loc_addr, loc_addr_joined, marker) {
        var infowindow = new google.maps.InfoWindow();
        infowindow.setContent('\
            <table>\
                <tr>\
                    <td style="max-width:260px; padding-right:15px; vertical-align:top;">\
                        <b>' + name + '</b><br />\
                        ' + loc_addr + '\
                    </td>\
                    <td style="vertical-align:top;">\
                        Directions<br/>\
                        <a href="//www.google.com/maps/dir/Current+Location/' + loc_addr_joined + '/data=!4m2!4m1!3e0" target="_blank" class="u-linkReset"><i class="far fa-car"></i></a>&nbsp;&nbsp;&nbsp;\
                        <a href="//www.google.com/maps/dir/Current+Location/' + loc_addr_joined + '/data=!4m2!4m1!3e3" target="_blank" class="u-linkReset"><i class="far fa-subway"></i></a>&nbsp;&nbsp;&nbsp;\
                        <a href="//www.google.com/maps/dir/Current+Location/' + loc_addr_joined + '/data=!4m2!4m1!3e2" target="_blank" class="u-linkReset"><i class="far fa-walking"></i></a>\
                    </td>\
                <tr>\
            <table>\
        ');
        infowindow.open(symphony.displayLocationMap_map, marker);
    }

    if (typeof window.displayLocationMap != "undefined") {
        $.each(window.displayLocationMap, function(i, loc) {
            loc.name = typeof loc.name != "undefined" ? loc.name : null;
            symphony.displayLocationMap(loc.elm, loc.addr, loc.name);
        });
    }

})();
